/**
 * Product media gallery videos are rendered with video_autoplay: true (see
 * snippets/product-media.liquid), which bakes the muted/autoplay attributes
 * into the <video> tag itself. However Horizon's <deferred-media> component
 * still gates the actual reveal + playback behind a manual click
 * (loadContent() is only called from the poster button's on:click handler).
 *
 * This script reveals + plays gallery videos automatically, without a click,
 * as soon as each one is in (or near) the viewport.
 */
(function () {
  var SELECTOR = 'media-gallery deferred-media[autoplay]:not([data-media-loaded])';

  function reveal(el) {
    if (typeof el.loadContent !== 'function' || el.hasAttribute('data-media-loaded')) return;
    el.loadContent(false);

    // loadContent() attempts video.play() immediately after cloning the
    // <video> into the DOM, which can silently fail if the browser hasn't
    // buffered enough data yet. Retry once the video reports it's ready.
    var video = el.querySelector('video');
    if (!video) return;
    var tryPlay = function () { video.play().catch(function () {}); };
    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
    }
  }

  function scan(root) {
    var candidates = (root || document).querySelectorAll(SELECTOR);
    if (!candidates.length) return;

    if (!('IntersectionObserver' in window)) {
      candidates.forEach(reveal);
      return;
    }

    // <deferred-media> itself is absolutely positioned with no intrinsic
    // size (0x0 box), so it never registers as intersecting. Observe its
    // sized ancestor (.product-media) instead, and reveal the matching
    // deferred-media descendant once that ancestor is in view.
    var targetToMedia = new Map();
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          var el = targetToMedia.get(entry.target);
          if (el) reveal(el);
        });
      },
      { rootMargin: '200px 0px' }
    );

    candidates.forEach(function (el) {
      var target = el.closest('.product-media') || el.parentElement || el;
      targetToMedia.set(target, el);
      io.observe(target);
    });
  }

  function run() { scan(document); }

  customElements.whenDefined('deferred-media').then(run).catch(run);

  // Re-scan after Shopify theme-editor section reloads, variant swaps, or
  // client-side navigation that swaps in a new gallery.
  document.addEventListener('shopify:section:load', run);
})();
